import React, { Fragment, ReactElement } from 'react';

// COMPONENTS
import Icon from '../Icon/Icon';

// ENUMS
import { Icons } from '../../enums/icons';

// INTERFACES
import { IStep } from '../../interfaces/Steps.interface';

// STYLES
import {
  SingleStepChildrenBox,
  SingleStepChildrenDot,
  SingleStepChildrenTitle,
  SingleStepLine,
  SingleStepNumberSquare,
  SingleStepTitle,
  StepChildrenEllipsis,
  StepChildrenLine
} from './styles';

const Step: React.FC<IStep> = ({ active, children, complete, step, title }: IStep) => {
  const getChildrenContent = () => {
    if (active && !complete) {
      return (children || []).map((child: IStep, idx: number) => {
        if (child.visible) {
          return (
            <SingleStepLine child={true} key={idx}>
              <SingleStepChildrenBox>
                <SingleStepChildrenDot active={child.active} complete={child.complete} />
              </SingleStepChildrenBox>
              <SingleStepChildrenTitle active={child.active} complete={child.complete}>
                {child.title}
              </SingleStepChildrenTitle>
            </SingleStepLine>
          );
        }
        return <Fragment key={idx}></Fragment>;
      });
    }

    return (
      <SingleStepLine child key={1}>
        <SingleStepChildrenBox>
          <SingleStepChildrenDot active={active} complete={complete} />
        </SingleStepChildrenBox>
        <SingleStepChildrenTitle active={active} complete={complete}>
          <StepChildrenEllipsis />
          <StepChildrenLine complete={complete} />
        </SingleStepChildrenTitle>
      </SingleStepLine>
    );
  };

  return (
    <>
      <SingleStepLine parent completeParent={!active} stepNum={step}>
        <SingleStepNumberSquare active={active} complete={complete}>
          {complete && !active ? <Icon type={Icons.CHECK_MARK} /> : step}
        </SingleStepNumberSquare>

        <SingleStepTitle active={active} complete={complete}>
          {title}
        </SingleStepTitle>
      </SingleStepLine>
      {(children || []).length > 0 && getChildrenContent()}
    </>
  );
};

export default Step;
